import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, EventEmitter, Output, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-popup',
  standalone: true,
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit, AfterViewInit {
  constructor(
    public dialogRef: MatDialogRef<PopupComponent>,  // Reference to the dialog
    @Inject(MAT_DIALOG_DATA) public data: any  // Inject data passed from parent
  ) {}
  @Output() decision: EventEmitter<string> = new EventEmitter<string>();
  showPopup: boolean = true;
  
  @ViewChild('leftPupil') leftPupil!: ElementRef;
  @ViewChild('rightPupil') rightPupil!: ElementRef;

  ngOnInit(): void {
    // Show popup after a delay
    setTimeout(() => {
      this.showPopup = true;
    }, 1000); // 1 second delay
  }

  ngAfterViewInit(): void {
    // Set up mouse movement event after the view is initialized
    document.addEventListener("mousemove", (e) => {
      this.moveEyes(e);
    });
  }

  // Function to handle pupil movement
  moveEyes(event: MouseEvent) {
    if (!this.leftPupil || !this.rightPupil) return;

    const leftEye = this.leftPupil.nativeElement.parentElement.getBoundingClientRect();
    const rightEye = this.rightPupil.nativeElement.parentElement.getBoundingClientRect();

    // Calculate the angle of the cursor relative to the eye centers
    const leftAngle = this.calculateAngle(event.clientX, event.clientY, leftEye);
    const rightAngle = this.calculateAngle(event.clientX, event.clientY, rightEye);

    // Move pupils
    this.updatePupilPosition(this.leftPupil.nativeElement, leftAngle);
    this.updatePupilPosition(this.rightPupil.nativeElement, rightAngle);
  }

  // Function to calculate the angle between the cursor and the eye center
  calculateAngle(cursorX: number, cursorY: number, eyeRect: DOMRect): number {
    const eyeCenterX = eyeRect.left + eyeRect.width / 2;
    const eyeCenterY = eyeRect.top + eyeRect.height / 2;
    return Math.atan2(cursorY - eyeCenterY, cursorX - eyeCenterX);
  }

  // Function to move the pupil based on the angle
  updatePupilPosition(pupil: HTMLElement, angle: number): void {
    const distance = 10; // Maximum distance pupil can move
    const x = Math.cos(angle) * distance;
    const y = Math.sin(angle) * distance;
    pupil.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px)`;
  }

  // Function for the 'Yes' button click
  onYesClick() {
    this.dialogRef.close('Yes');
  }

  // Function for the 'No' button click
  onNoClick() {
    this.dialogRef.close('No');
  }
}
